import React from 'react';
import { compose, withState } from 'recompose';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';

import device from '../../../device';

const Image = () => (
    <StaticQuery
        query={graphql`
            query {
                placeholderImage: file(relativePath: { eq: "achievements/achievement2.jpg" }) {
                    childImageSharp {
                        fluid(maxHeight: 300) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        `}
        render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} />}
    />
);

const AchievementContainer = styled.div`
    position: relative;
    text-align: center;
    line-height: 1.5rem;

    @media ${device.laptop} {
        display: flex;
        align-items: center;
        height: 100%;
    }
`;

const ImageContainer = styled.div`
    opacity: ${({ isTextVisible }: { isTextVisible: boolean }) => (isTextVisible ? 0.2 : 1)};

    @media ${device.laptop} {
        width: 20rem;
        opacity: 1;
    }
`;

const TextContainerOuter = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: ${props => (props.isTextVisible ? 1 : 0)};

    @media ${device.laptop} {
        opacity: 1;
        transform: translate(0%, 0%);
        top: 0;
        left: 0;
        position: relative;
    }
`;

const TextContainerInner = styled.div`
    display: flex;
    flex-direction: column;
    width: 70%;
    direction: rtl;
    white-space: normal;
`;

const FirstLine = styled.div`
    font-size: 1.3rem;
    line-height: 2rem;
    font-weight: bold;

    @media ${device.tablet} {
        margin-bottom: 1rem;
        font-size: 2.6rem;
    }

    @media ${device.laptop} {
        margin-bottom: 1rem;
        font-size: 1.3rem;
    }
`;

const Text = styled.div`
    font-size: 1rem;

    @media ${device.tablet} {
        font-size: 1.8rem;
        line-height: 2rem;
    }

    @media ${device.laptop} {
        font-size: 1rem;
        line-height: 1.5rem;
    }
`;

const LastLine = styled.div`
    font-weight: bold;

    @media ${device.tablet} {
        margin-top: 1rem;
        font-size: 2rem;
        line-height: 2rem;
    }

    @media ${device.laptop} {
        margin-top: 0.7rem;
        font-size: 1.5rem;
    }
`;

const Achievement = ({ isTextVisible, setIsTextVisible }) => (
    <AchievementContainer onClick={() => setIsTextVisible(!isTextVisible)}>
        <div>
            <ImageContainer isTextVisible={isTextVisible}>
                <Image />
            </ImageContainer>
        </div>
        <TextContainerOuter isTextVisible={isTextVisible}>
            <TextContainerInner>
                <FirstLine>ספיר האלופה שלי</FirstLine>
                <Text>
                    <div>מתאמנת באופן קבוע, ולא מוותרת לעצמה!</div>
                    <div>כי רצון יש לה!</div>
                    <div>מוטיבציה יש!</div>
                    <div>מטרה יש!</div>
                </Text>
                <LastLine>התהליך לאורח חיים בריא יצא לדרך....</LastLine>
            </TextContainerInner>
        </TextContainerOuter>
    </AchievementContainer>
);

export default compose(withState('isTextVisible', 'setIsTextVisible', false))(Achievement);

export const Achievement2Image = Image;
